var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [
        {
            "name": "Result",
            "fields": [
                {
                    "rule": "optional",
                    "type": "Code",
                    "name": "code",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "msg",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "google.protobuf.Any",
                    "name": "data",
                    "id": 3
                }
            ]
        },
        {
            "name": "google",
            "fields": [],
            "messages": [
                {
                    "name": "protobuf",
                    "fields": [],
                    "options": {
                        "csharp_namespace": "Google.Protobuf.WellKnownTypes",
                        "go_package": "github.com/golang/protobuf/ptypes/any",
                        "java_package": "com.google.protobuf",
                        "java_outer_classname": "AnyProto",
                        "java_multiple_files": true,
                        "java_generate_equals_and_hash": true,
                        "objc_class_prefix": "GPB"
                    },
                    "messages": [
                        {
                            "name": "Any",
                            "fields": [
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "type_url",
                                    "id": 1
                                },
                                {
                                    "rule": "optional",
                                    "type": "bytes",
                                    "name": "value",
                                    "id": 2
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "enums": [
        {
            "name": "Code",
            "values": [
                {
                    "name": "DEFAULT",
                    "id": 0
                },
                {
                    "name": "SC_SUCCESS",
                    "id": 1
                },
                {
                    "name": "SC_THIRD_PARTY_ALREADY_BIND",
                    "id": 256
                },
                {
                    "name": "SC_THIRD_CHECK_USER_NOT_REGISTER",
                    "id": 257
                },
                {
                    "name": "SC_NEED_BIND_PHONE",
                    "id": 258
                },
                {
                    "name": "SC_PARAMETER_INVALID",
                    "id": 4096
                },
                {
                    "name": "SC_ADMIN_NO_PERMISSION",
                    "id": 4352
                },
                {
                    "name": "SC_ACCOUTN_USER_TOKEN_NOTMATCH",
                    "id": 8192
                },
                {
                    "name": "SC_ACCOUNT_IS_VISTOR",
                    "id": 8194
                },
                {
                    "name": "SC_LOGINED_IN_OTHER_DEVICE",
                    "id": 8193
                },
                {
                    "name": "SC_SMS_VERIFY_CODE_NOMOBILE",
                    "id": 4097
                },
                {
                    "name": "SC_SMS_VERIFY_CODE_FAIL",
                    "id": 4098
                },
                {
                    "name": "SC_SMS_VERIFY_CODE_NOTMATCH",
                    "id": 4099
                },
                {
                    "name": "SC_ACCOUNT_MOBILE_PHONE_REPETITION",
                    "id": 4100
                },
                {
                    "name": "SC_ACCOUNT_MOBILE_PHONE_ALLREADY_BIND",
                    "id": 4101
                },
                {
                    "name": "SC_ACCOUTN_USER_NAME_FORBIDDEN",
                    "id": 4102
                },
                {
                    "name": "SC_ACCOUTN_THIRD_CHECK_FAIL",
                    "id": 4103
                },
                {
                    "name": "SC_ACCOUNT_USER_NAME_OVER_LONG",
                    "id": 4104
                },
                {
                    "name": "SC_ACCOUNT_LIVE_CODE_OVER_LONG",
                    "id": 4105
                },
                {
                    "name": "SC_ACCOUNT_LIVE_CODE_EMAIL_WHITE",
                    "id": 4106
                },
                {
                    "name": "SC_ACCOUNT_LIVE_CODE_NOT_STANDARD",
                    "id": 4112
                },
                {
                    "name": "SC_ACCOUNT_LIVE_CODE_EXIST",
                    "id": 4113
                },
                {
                    "name": "SC_ACCOUNT_LIVE_UPDATE_FAIL",
                    "id": 4114
                },
                {
                    "name": "SC_ACCOUNT_PASSWORD_ERROR",
                    "id": 4115
                },
                {
                    "name": "SC_ACCOUNT_USER_NOT_EXIST",
                    "id": 4116
                },
                {
                    "name": "SC_ACCOUNT_LIVE_CODE_TOO_SHORT",
                    "id": 4117
                },
                {
                    "name": "SC_ACCOUNT_SIGNATURE_OVER_LONG",
                    "id": 4118
                },
                {
                    "name": "SC_ACCOUTN_USER_FORBIDDEN",
                    "id": 4119
                },
                {
                    "name": "SC_ACCOUNT_RANDOM_NOTEXIST",
                    "id": 4120
                },
                {
                    "name": "SC_ACCOUNT_RANDOM_NOTSCAN",
                    "id": 4121
                },
                {
                    "name": "SC_ACCOUNT_RANDOM_SCANNED",
                    "id": 4128
                },
                {
                    "name": "SC_ACCOUNT_LIVE_CODE_NOLY_MODIFY_ONCE",
                    "id": 4129
                },
                {
                    "name": "SC_ACCOUNT_USER_OR_PASSWORD_ERROR",
                    "id": 4130
                },
                {
                    "name": "SC_EMAIL_SEND_OVER_LIMIT",
                    "id": 4131
                },
                {
                    "name": "SC_EMAIL_VERIFY_INVALID",
                    "id": 4132
                },
                {
                    "name": "SC_EMAIL_NOT_VERIFY",
                    "id": 4133
                },
                {
                    "name": "SC_NEED_REGISTER",
                    "id": 4134
                },
                {
                    "name": "SC_ACCOUNT_HAVE_NO_BIND_MOBILE",
                    "id": 4135
                },
                {
                    "name": "SC_ACCOUNT_DID_FORBIDDEN",
                    "id": 4136
                },
                {
                    "name": "SC_SMS_SEND_CODE_BEYOND_LIMIT",
                    "id": 4137
                },
                {
                    "name": "SC_SENSITIVE_CONTENT",
                    "id": 4609
                },
                {
                    "name": "SC_ACCOUNT_USER_USERNAME_IS_HIDDEN",
                    "id": 4610
                },
                {
                    "name": "SC_MALL_GIFT_NOT_EXIST",
                    "id": 12289
                },
                {
                    "name": "SC_MALL_TRANSACTION_REPEATED",
                    "id": 12290
                },
                {
                    "name": "SC_MALL_MONEY_NOT_ENOUGH",
                    "id": 12291
                },
                {
                    "name": "SC_MALL_TRANSACTION_NOT_EXIST",
                    "id": 12292
                },
                {
                    "name": "SC_MALL_PRODUCT_NOT_AVAILABLE",
                    "id": 12293
                },
                {
                    "name": "SC_MALL_ORDER_NOT_EXIST",
                    "id": 12294
                },
                {
                    "name": "SC_MALL_UNIFIED_ORDER_FAIL",
                    "id": 12295
                },
                {
                    "name": "SC_MALL_PAY_FAIL",
                    "id": 12296
                },
                {
                    "name": "SC_MALL_PAY_QUERY_FAIL",
                    "id": 12297
                },
                {
                    "name": "SC_MALL_IAP_VALIDATE_FAIL",
                    "id": 12298
                },
                {
                    "name": "SC_MALL_ORDER_EXIST_NOT_FINISHED",
                    "id": 12299
                },
                {
                    "name": "SC_MALL_NOT_BIND_WECHAT",
                    "id": 12300
                },
                {
                    "name": "SC_MALL_EXCEED_WITHDRAW_TIMES",
                    "id": 12301
                },
                {
                    "name": "SC_MALL_EXCEED_WITHDRAW_QUOTA",
                    "id": 12302
                },
                {
                    "name": "SC_MALL_WITHDRAW_FAIL",
                    "id": 12303
                },
                {
                    "name": "SC_MALL_WITHDRAW_LESS_THAN_MIN",
                    "id": 12304
                },
                {
                    "name": "SC_MALL_WITHDRAW_GREATER_THAN_MAX",
                    "id": 12305
                },
                {
                    "name": "SC_MALL_WITHDRAW_FREQ_LIMIT",
                    "id": 12306
                },
                {
                    "name": "SC_MALL_WITHDRAW_SENDNUM_LIMIT",
                    "id": 12307
                },
                {
                    "name": "SC_MALL_NOT_BIND_PAYPAL",
                    "id": 12308
                },
                {
                    "name": "SC_MALL_IAB_VALIDATE_FAIL",
                    "id": 12309
                },
                {
                    "name": "SC_MALL_BUY_GUARD_DIAMOND_LOW",
                    "id": 12310
                },
                {
                    "name": "SC_MALL_TRANSLATE_NOT_SUPPORT",
                    "id": 12311
                },
                {
                    "name": "SC_MALL_TRANSLATE_CLOSED",
                    "id": 12312
                },
                {
                    "name": "SC_MALL_GIFT_SEND_VIP_LIMIT",
                    "id": 12313
                },
                {
                    "name": "SC_MALL_GIFT_NOT_ALLOW",
                    "id": 12320
                },
                {
                    "name": "SC_MALL_GIFT_NEED_RECHARGE",
                    "id": 12321
                },
                {
                    "name": "SC_MALL_ACC_BILL_NOT_ENOUGH",
                    "id": 12322
                },
                {
                    "name": "SC_MALL_USER_FROZEN",
                    "id": 12323
                },
                {
                    "name": "SC_MALL_RECHARGE_REPEAT",
                    "id": 12324
                },
                {
                    "name": "SC_MALL_RECHARGE_REWARD_REPEAT",
                    "id": 12325
                },
                {
                    "name": "SC_MALL_RECHARGE_REWARD_INVALID",
                    "id": 12326
                },
                {
                    "name": "SC_MALL_SHAREREDPACKET_TOTALAMOUNT_INVALID",
                    "id": 12327
                },
                {
                    "name": "SC_MALL_SHAREREDPACKET_SPLITNUM_INVALID",
                    "id": 12328
                },
                {
                    "name": "SC_MALL_SHAREREDPACKET_SPLITAMOUNT_INVALID",
                    "id": 12329
                },
                {
                    "name": "SC_MALL_GOODS_NOT_EXIST",
                    "id": 12336
                },
                {
                    "name": "SC_MALL_BROADCAST_NOT_OPEN",
                    "id": 12337
                },
                {
                    "name": "SC_MALL_FIXEDCONTENT_NOT_EXIST",
                    "id": 12338
                },
                {
                    "name": "SC_MALL_GIFT_GUARD_TOO_LOW",
                    "id": 12339
                },
                {
                    "name": "SC_MALL_FIGHT_OVER",
                    "id": 12340
                },
                {
                    "name": "SC_MALL_BIGBALL_OVER",
                    "id": 12341
                },
                {
                    "name": "SC_MALL_PROP_LEFT_AMOUNT_NOT_ENOUGH",
                    "id": 12342
                },
                {
                    "name": "SC_MALL_PROP_SAME_EXIST",
                    "id": 12343
                },
                {
                    "name": "SC_MALL_PLAY_NOT_OPEN",
                    "id": 12344
                },
                {
                    "name": "SC_MALL_MOUNT_CANNOTREPURCHASE",
                    "id": 12345
                },
                {
                    "name": "SC_RANKING_VIP_INVISIBLE_LIMIT",
                    "id": 14593
                },
                {
                    "name": "SC_RANKING_VIP_INVISIBLE_OFF",
                    "id": 14594
                },
                {
                    "name": "SC_CONTACT_ALREADY_FRIEND",
                    "id": 16385
                },
                {
                    "name": "SC_LIVE_ROOM_NOT_EXIST",
                    "id": 20481
                },
                {
                    "name": "SC_LIVE_ROOM_DISABLED",
                    "id": 20482
                },
                {
                    "name": "SC_LIVE_ROOM_NO_PERMISSION",
                    "id": 20483
                },
                {
                    "name": "SC_LIVE_ROOM_USER_GRADE_NOT_ENOUGH",
                    "id": 20484
                },
                {
                    "name": "SC_LIVE_ROOM_SPECIAL_NOT_CREATE",
                    "id": 20485
                },
                {
                    "name": "SC_LIVE_ROOM_ADMIN_SHUTUP_FAIL",
                    "id": 20486
                },
                {
                    "name": "SC_LIVE_ROOM_ADMIN_LIFTED_FAIL",
                    "id": 20487
                },
                {
                    "name": "SC_LIVE_ROOM_ADMIN_SHUTUP_UIDS_ERROR",
                    "id": 20488
                },
                {
                    "name": "SC_LIVE_ROOM_NO_TEL_AUTH",
                    "id": 20489
                },
                {
                    "name": "SC_LIVE_ROOM_FORCED_OUT",
                    "id": 20490
                },
                {
                    "name": "SC_LIVE_ROOM_POLICY_DISABLED",
                    "id": 20491
                },
                {
                    "name": "SC_LIVE_ROOM_RID_UID_NOTMATCH",
                    "id": 20492
                },
                {
                    "name": "SC_LIVE_ROOM_NO_REALNAME_AUTH",
                    "id": 20496
                },
                {
                    "name": "SC_LIVE_ROOM_NOT_IN_MULTILIVE",
                    "id": 20497
                },
                {
                    "name": "SC_LIVE_ROOM_PAY_FAILED",
                    "id": 20498
                },
                {
                    "name": "SC_LIVE_ROOM_CANNOT_MULTILIVE",
                    "id": 20499
                },
                {
                    "name": "SC_LIVE_ROOM_MULTILIVE_MEMBERS_LIMIT",
                    "id": 20500
                },
                {
                    "name": "SC_LIVE_ROOM_MULTILIVE_CREATE_MEETINGROOM_FAILED",
                    "id": 20501
                },
                {
                    "name": "SC_LIVE_ROOM_MULTILIVE_FINISH",
                    "id": 20502
                },
                {
                    "name": "SC_LIVE_ROOM_IS_LIVING",
                    "id": 20503
                },
                {
                    "name": "SC_LIVE_ROOM_PRIVATELIVE_NOT_ALLOW",
                    "id": 20504
                },
                {
                    "name": "SC_LIVE_ROOM_CHARGE_NOT_ALLOW",
                    "id": 20505
                },
                {
                    "name": "SC_LIVE_ROOM_CHARGE_BELOW_MIN",
                    "id": 20506
                },
                {
                    "name": "SC_LIVE_ROOM_AUDIENCE_LIMIT_ALLOW",
                    "id": 20507
                },
                {
                    "name": "SC_LIVE_ROOM_LIVE_NEED_CHARGE",
                    "id": 20508
                },
                {
                    "name": "SC_LIVE_ROOM_NUMBER_REACHED_TOPLIMIT",
                    "id": 20512
                },
                {
                    "name": "SC_LIVE_ROOM_VOICE_NOT_ALLOW",
                    "id": 20513
                },
                {
                    "name": "SC_LIVE_ROOM_USER_NOT_ONLINE",
                    "id": 20514
                },
                {
                    "name": "SC_LIVE_ROOM_APPLY_MULTILIVE_NOT_ALLOW",
                    "id": 20515
                },
                {
                    "name": "SC_LIVE_ROOM_NO_MEMBER",
                    "id": 20516
                },
                {
                    "name": "SC_LIVE_ROOM_NO_INVITE",
                    "id": 20517
                },
                {
                    "name": "SC_LIVE_ROOM_MULTILIVE_FREEJOINTIME_EMPTY",
                    "id": 20518
                },
                {
                    "name": "SC_LIVE_ROOM_MF_VIP_LIMIT",
                    "id": 20519
                },
                {
                    "name": "SC_LIVE_ROOM_MF_COUNTRY_LIMIT",
                    "id": 20520
                },
                {
                    "name": "SC_LIVE_ROOM_INVITE_LIMIT_DAILY",
                    "id": 20521
                },
                {
                    "name": "SC_ACTIVITY_SEND_DIAMOND_TIME_END",
                    "id": 24577
                },
                {
                    "name": "SC_ACTIVITY_SEND_DIAMOND_OVER_LIMIT",
                    "id": 24578
                },
                {
                    "name": "SC_ACTIVITY_SEND_DIAMOND_ALREADY",
                    "id": 24579
                },
                {
                    "name": "SC_ACTIVITY_NO_RECHARGE",
                    "id": 24580
                },
                {
                    "name": "SC_ACTIVITY_NOT_CONDITIONS",
                    "id": 24581
                },
                {
                    "name": "SC_SYSTEM_ERROR",
                    "id": 16777215
                },
                {
                    "name": "SC_ZMXY_AUTH_BIND_SUCCESS",
                    "id": 28673
                },
                {
                    "name": "SC_ZMXY_AUTH_HAS_BEEN_USEED",
                    "id": 28674
                },
                {
                    "name": "SC_ZMXY_AUTH_HAS_BIND",
                    "id": 28675
                },
                {
                    "name": "SC_ZMXY_AUTH_ERROR",
                    "id": 28676
                },
                {
                    "name": "SC_REDPACKET_OVERDUE_ERROR",
                    "id": 32769
                },
                {
                    "name": "SC_REDPACKET_DISTRIBUTED_ERROR",
                    "id": 32770
                },
                {
                    "name": "SC_REDPACKET_REPEAT_ERROR",
                    "id": 32771
                },
                {
                    "name": "SC_REDPACKET_DELAYTIME_ERROR",
                    "id": 32772
                },
                {
                    "name": "SC_PERMISSIONUSE_NOT_ALLOW",
                    "id": 36865
                },
                {
                    "name": "SC_PERMISSIONUSE_LOW_PERMISSION",
                    "id": 36866
                },
                {
                    "name": "SC_PERMISSIONUSE_OVER_ROOMMAX",
                    "id": 36867
                },
                {
                    "name": "SC_PERMISSIONUSE_OVER_DAYMAX",
                    "id": 36868
                },
                {
                    "name": "SC_PERMISSIONUSE_OVER_ADD_LIMIT",
                    "id": 36869
                },
                {
                    "name": "SC_PERMISSIONUSE_ERROR",
                    "id": 36870
                },
                {
                    "name": "SC_PERMISSIONUSE_REPEAT_ERROR",
                    "id": 36871
                },
                {
                    "name": "SC_ACTIVITY_EXCHANGE_REPEATED",
                    "id": 65537
                },
                {
                    "name": "SC_ACTIVITY_POINT_NOT_ENOUGH",
                    "id": 65538
                },
                {
                    "name": "SC_PACK_TRANSACTION_REPEATED",
                    "id": 69633
                },
                {
                    "name": "SC_PACK_GIFT_NOT_AVAILABLE",
                    "id": 69634
                },
                {
                    "name": "SC_PACK_GIFT_EXPIRE",
                    "id": 69635
                },
                {
                    "name": "SC_PACK_TRANSACTION_NOT_EXIST",
                    "id": 69636
                },
                {
                    "name": "SC_PACK_FULL",
                    "id": 69637
                },
                {
                    "name": "SC_DYNAMIC_COMMENT_FREQUENCY_LIMITED",
                    "id": 73729
                },
                {
                    "name": "SC_DYNAMIC_COMMENT_WORDS_OVER_LONG",
                    "id": 73730
                },
                {
                    "name": "SC_DYNAMIC_NOT_EXIST_OR_DELETED",
                    "id": 73731
                },
                {
                    "name": "SC_DYNAMIC_HAS_NO_RIGHT",
                    "id": 73732
                },
                {
                    "name": "SC_DYNAMIC_IN_CALCULATION",
                    "id": 73733
                },
                {
                    "name": "SC_DYNAMIC_EMPTY_NEED_GET_RECOMMEND_ANCHOR",
                    "id": 73734
                },
                {
                    "name": "SC_DYNAMIC_LIMIT_FREQUENTLY_REPEAT_COMMENT",
                    "id": 73735
                },
                {
                    "name": "SC_DYNAMIC_NOT_VIDEO_COMMENT",
                    "id": 73736
                },
                {
                    "name": "SC_CHECKIN_ALREADY",
                    "id": 77825
                },
                {
                    "name": "SC_FAN_GROUP_TITLE_CHANGE_POINT_NOT_ENOUGH",
                    "id": 94465
                },
                {
                    "name": "SC_FAN_GROUP_NOT_EXIST",
                    "id": 94466
                },
                {
                    "name": "SC_FAN_GROUP_NOT_FAN",
                    "id": 94467
                },
                {
                    "name": "SC_FAN_GROUP_SELF_JOIN_ERROR",
                    "id": 94468
                },
                {
                    "name": "SC_FAN_TASK_NOT_EXIST",
                    "id": 94469
                },
                {
                    "name": "SC_FAN_TASK_TYPE_NOT_EXIST",
                    "id": 94470
                },
                {
                    "name": "SC_FAN_TASK_MAXIMUM_TIME_REACHED",
                    "id": 94471
                },
                {
                    "name": "SC_FAN_PERMISSION_NO",
                    "id": 94472
                },
                {
                    "name": "SC_ACTIVITY_REWARD_ALREADY",
                    "id": 81921
                },
                {
                    "name": "SC_ACTIVITY_REWARD_CANNOT",
                    "id": 81922
                },
                {
                    "name": "SC_RANKING_GAME_NOTAUTHORITY",
                    "id": 86017
                },
                {
                    "name": "IM_SYSTEM_ERROR",
                    "id": 90113
                },
                {
                    "name": "IM_CREATE_PERMISSION_DENIED",
                    "id": 90114
                },
                {
                    "name": "IM_BEYOND_GROUP_NUM_LIMIT",
                    "id": 90115
                },
                {
                    "name": "IM_BEYOND_GROUP_USER_NUM_LIMIT",
                    "id": 90116
                },
                {
                    "name": "IM_PERMISSION_DENIED",
                    "id": 90117
                },
                {
                    "name": "IM_GROUP_INVALID",
                    "id": 90118
                },
                {
                    "name": "IM_INVITE_INVALID",
                    "id": 90119
                },
                {
                    "name": "SC_FOLLOW_YOU_ARE_IN_OTHERS_BLACKLIST",
                    "id": 98305
                },
                {
                    "name": "SC_FOLLOW_ALREADY_REACH_MAX_FOLLOW",
                    "id": 98306
                },
                {
                    "name": "SC_GIFTITEM_SAMENAME",
                    "id": 98307
                },
                {
                    "name": "GIFTO_ACCOUNT_LOGING",
                    "id": 1052673
                },
                {
                    "name": "GIFTO_ACCOUNT_ALREADY_ACTIVATE",
                    "id": 1052674
                },
                {
                    "name": "GIFTO_ACCOUNT_WAIT_ACTIVATE",
                    "id": 1052675
                },
                {
                    "name": "GIFTO_ACCOUNT_EXPIRE_ACTIVATE",
                    "id": 1052676
                },
                {
                    "name": "GIFTO_ACCOUNT_NOT_BIND",
                    "id": 1052677
                },
                {
                    "name": "GIFTO_EMAIL_VERIFY_INVALID",
                    "id": 1052678
                },
                {
                    "name": "GIFTO_ACCOUNT_USER_OR_PASSWORD_ERROR",
                    "id": 1052679
                },
                {
                    "name": "GIFTO_EMAIL_SEND_OVER_LIMIT",
                    "id": 1052680
                },
                {
                    "name": "GIFTO_EMAIL_NOT_VERIFY",
                    "id": 1052681
                },
                {
                    "name": "GIFTO_NOT_CURRENT_USER_BIND",
                    "id": 1052682
                },
                {
                    "name": "GIFTO_ACCOUNT_PASSWORD_ERROR",
                    "id": 1052683
                },
                {
                    "name": "GIFTO_KYC_NOT_SCUCCESS",
                    "id": 1052684
                },
                {
                    "name": "GIFTO_ACCOUNT_NO_AUTHORITY",
                    "id": 1052685
                },
                {
                    "name": "GIFTO_EMAIL_ALREADY_REGISTER",
                    "id": 1052686
                },
                {
                    "name": "WALLET_JSON_NOT_VALID",
                    "id": 1056769
                },
                {
                    "name": "WALLET_REQUEST_MISSING",
                    "id": 1056770
                },
                {
                    "name": "WALLET_CURRENCY_NOT_SUPPORTED",
                    "id": 1056771
                },
                {
                    "name": "WALLET_EXCEED_MAX_LENGRH",
                    "id": 1056772
                },
                {
                    "name": "WALLET_INVALID_TOKEN",
                    "id": 1056773
                },
                {
                    "name": "WALLET_METHOD_NOT_ALLOWED",
                    "id": 1056774
                },
                {
                    "name": "WALLET_HAD_REPEAT_VALID",
                    "id": 1056775
                },
                {
                    "name": "WALLET_MINIMUM_COIN_REQUIRED",
                    "id": 1056776
                },
                {
                    "name": "WALLET_BALANCE_NOT_ENOUGH",
                    "id": 1056777
                },
                {
                    "name": "WALLET_TRANSFER_FEE_TYPE_NOT_SUPPORTED",
                    "id": 1056778
                },
                {
                    "name": "WALLET_TRANSFER_TYPE_NOT_SUPPORTED",
                    "id": 1056779
                },
                {
                    "name": "WALLET_PASSPHRASE_NOT_CORRECT",
                    "id": 1056780
                },
                {
                    "name": "WALLET_SENDER_IDENTITY_NOT_FOUNT",
                    "id": 1056781
                },
                {
                    "name": "WALLET_RECEIVER_IDENTITY_NOT_FOUNT",
                    "id": 1056782
                },
                {
                    "name": "WALLET_FOR_DEPOSITING",
                    "id": 1056783
                },
                {
                    "name": "WALLET_OPEN_UCOINS_NOT_ENOUGH",
                    "id": 1060865
                },
                {
                    "name": "WALLET_OPEN_TRANSACTION_REPEATED",
                    "id": 1060866
                },
                {
                    "name": "WALLET_OPEN_TRANSACTION_NOT_EXIST",
                    "id": 1060867
                },
                {
                    "name": "WALLET_OPEN_FAIL",
                    "id": 1060868
                },
                {
                    "name": "WALLET_OPEN_TRANSACTION_NOT_END",
                    "id": 1060869
                },
                {
                    "name": "WALLET_OPEN_TRANSACTION_DAY_LIMIT",
                    "id": 1060870
                },
                {
                    "name": "WALLET_OPEN_TRANSACTION_MONTH_LIMIT",
                    "id": 1060871
                },
                {
                    "name": "WALLET_OPEN_TRANSACTION_YEAR_LIMIT",
                    "id": 1060872
                },
                {
                    "name": "WALLET_OPEN_TRANSACTION_FREQUENTLY",
                    "id": 1060873
                },
                {
                    "name": "WALLET_OPEN_TRANSACTION_ONCHAIN_SHUT",
                    "id": 1060874
                },
                {
                    "name": "WALLET_OPEN_PAYPASS_NOT_SETTING",
                    "id": 1060875
                },
                {
                    "name": "WALLET_OPEN_USER_TRANSACTION_SHUT",
                    "id": 1060876
                },
                {
                    "name": "WALLET_OPEN_USER_DEPOT_LOCKED",
                    "id": 1060877
                },
                {
                    "name": "WALLET_OPEN_FIAT_PRODUCT_NOT_AVAILABLE",
                    "id": 1060878
                },
                {
                    "name": "WALLET_OPEN_FIAT_PRODUCT_REFRESHED",
                    "id": 1060879
                },
                {
                    "name": "WALLET_OPEN_UNIFIED_ORDER_FAIL",
                    "id": 1060880
                },
                {
                    "name": "WALLET_OPEN_ORDER_NOT_EXIST",
                    "id": 1060881
                },
                {
                    "name": "WALLET_OPEN_PAY_QUERY_FAIL",
                    "id": 1060882
                },
                {
                    "name": "WALLET_OPEN_PAY_FAIL",
                    "id": 1060883
                },
                {
                    "name": "WALLET_OPEN_FIAT_RECHARGE_DAY_LIMIT",
                    "id": 1060884
                },
                {
                    "name": "WALLET_OPEN_UCOINS_EXCHANGE_REGION_CLOSE",
                    "id": 1060885
                },
                {
                    "name": "WALLET_OPEN_UCOINS_HAS_EXCHANGE",
                    "id": 1060886
                },
                {
                    "name": "WALLET_OPEN_UCOINS_MORE_MAX",
                    "id": 1060887
                },
                {
                    "name": "WALLET_OPEN_UCOINS_LESS_MIN",
                    "id": 1060888
                },
                {
                    "name": "WALLET_OPEN_USABLE_BALANCE_NOT_ENOUGH",
                    "id": 1060889
                },
                {
                    "name": "GIFTO_MALL_REQUEST_SUCCESS",
                    "id": 1064960
                },
                {
                    "name": "GIFTO_MALL_DUPLICATED_TRANSACTION",
                    "id": 1064961
                },
                {
                    "name": "GIFTO_MALL_GTO_BALANCE_NOT_ENOUGH",
                    "id": 1064962
                },
                {
                    "name": "GIFTO_MALL_PRARAMETER_INVALID",
                    "id": 1064963
                },
                {
                    "name": "GIFTO_MALL_GIFT_NOT_EXIST",
                    "id": 1064964
                },
                {
                    "name": "GIFTO_MALL_UNKNOWN_EXCEPTION",
                    "id": 1064965
                },
                {
                    "name": "GIFTO_MALL_GIFT_SEND_VIP_LIMIT",
                    "id": 1064966
                },
                {
                    "name": "GIFTO_MALL_GIFTO_RECEIVE_NOT_AUTHORITY",
                    "id": 1064967
                },
                {
                    "name": "GREETING_CARDS_REQUEST_SUCCESS",
                    "id": 1069056
                },
                {
                    "name": "GREETING_CARDS_NOT_GIFT",
                    "id": 1069057
                },
                {
                    "name": "GREETING_CARDS_REQUEST_ERROR",
                    "id": 1069058
                },
                {
                    "name": "GREETING_CARDS_GIFT_ID_ERROR",
                    "id": 1069059
                },
                {
                    "name": "GREETING_CARDS_GIFT_ID_NULL",
                    "id": 1069060
                },
                {
                    "name": "GREETING_CARDS_STATUS_NO_PASS",
                    "id": 1069061
                },
                {
                    "name": "GREETING_CARDS_IP_COUNT_FULL",
                    "id": 1069062
                },
                {
                    "name": "PK_USER_NOT_IN_PK",
                    "id": 1073152
                },
                {
                    "name": "PK_USER_INCONVENIENT",
                    "id": 1073153
                },
                {
                    "name": "PK_USER_OFFLINE",
                    "id": 1073154
                },
                {
                    "name": "PK_SEND_MSG_FAIL",
                    "id": 1073155
                },
                {
                    "name": "PK_USER_ALREADY_IN_INVITE",
                    "id": 1073156
                },
                {
                    "name": "PK_USER_ALREADY_IN_MATCH_WAITING",
                    "id": 1073157
                },
                {
                    "name": "PK_INVALID_USER",
                    "id": 1073158
                },
                {
                    "name": "PK_INVITE_UUID_EXPIRED",
                    "id": 1073159
                }
            ]
        }
    ]
}).build();
export default _root;



// WEBPACK FOOTER //
// ./src/js/openjs/deps/login/pb/resultresponse.pb.js